export const environment = {
  production: false,
  portalURL: '/api-portal',
  wsURL: '/api-websocket',
  contractURL:'/api-contract',
  docStoreURL: '/api-docstore',
};
